"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteringSettingsT = exports.FilteringSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const filtering_type_js_1 = require("../../solarxr-protocol/datatypes/filtering-type.js");
class FilteringSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsFilteringSettings(bb, obj) {
        return (obj || new FilteringSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsFilteringSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new FilteringSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    type() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : filtering_type_js_1.FilteringType.NONE;
    }
    /**
     * 0 to 1. A higher value results in more smoothing or prediction
     */
    amount() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    static startFilteringSettings(builder) {
        builder.startObject(2);
    }
    static addType(builder, type) {
        builder.addFieldInt8(0, type, filtering_type_js_1.FilteringType.NONE);
    }
    static addAmount(builder, amount) {
        builder.addFieldFloat32(1, amount, 0.0);
    }
    static endFilteringSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createFilteringSettings(builder, type, amount) {
        FilteringSettings.startFilteringSettings(builder);
        FilteringSettings.addType(builder, type);
        FilteringSettings.addAmount(builder, amount);
        return FilteringSettings.endFilteringSettings(builder);
    }
    unpack() {
        return new FilteringSettingsT(this.type(), this.amount());
    }
    unpackTo(_o) {
        _o.type = this.type();
        _o.amount = this.amount();
    }
}
exports.FilteringSettings = FilteringSettings;
class FilteringSettingsT {
    constructor(type = filtering_type_js_1.FilteringType.NONE, amount = 0.0) {
        this.type = type;
        this.amount = amount;
    }
    pack(builder) {
        return FilteringSettings.createFilteringSettings(builder, this.type, this.amount);
    }
}
exports.FilteringSettingsT = FilteringSettingsT;
